import React from 'react';

import { styled, Tooltip, TooltipProps } from '@mui/material';

import './ExplainTips.scss';
import { tooltipClasses } from '@mui/material';
import { padding } from '@mui/system';

interface ExplainTipsProps {
  text: string
  tipStyle: any
  placement?: string
}

const ExplainTips = (props: ExplainTipsProps) => {


  // console.log('ExplainTooltip', props);

  const { text, tipStyle } = props;
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f0eff0',
      color: '#4a4a4a',
      padding: 5,
      maxWidth: 270,
      fontSize: theme.typography.pxToRem(12),
      // border: '1px solid #dadde9',
      boxShadow: '2px 2px 4px 2px rgba(0, 0, 0, 0.3)'
    },
  }));

  return (
    <HtmlTooltip title={
      <div dangerouslySetInnerHTML={{ __html: text }}></div>
    } placement={props.placement == 'bottom' ? "bottom" : "top"}>
      <div className="questionmark" style={tipStyle}></div>
    </HtmlTooltip>
  )
}

export default ExplainTips;